import { Vue, Component, Prop } from 'vue-property-decorator';
import * as mws from '../../../shared/MwsViewModels';
import template from './generic-text-panel.vue';

@Component({
  mixins: [template],
})
export default class GenericTextPanel extends Vue {
  @Prop()
  data: mws.GenericTextPanel;
}
